import React from 'react';
import serviceBanner from '../../assets/service-banner.png';
import overlayServiceBanner from '../../assets/overlay-service-banner.png';
import experienceLogo from '../../assets/experience-logo.svg';
import loyaltyLogo from '../../assets/loyality-logo.svg';
import trustLogo from '../../assets/trust-logo.svg';

const ServiceBanner = () => {
  return (
    <div 
      className="w-full bg-cover bg-center relative mb-12 md:mb-20 md:my-20 py-8 md:py-20" 
      style={{ backgroundImage: `url(${serviceBanner})` }}
    >
      {/* Full-width and full-height Overlay Image */}
      <div className="absolute inset-0">
        <img src={overlayServiceBanner} alt="Overlay" className="w-full h-full object-cover" />
      </div>

      {/* Banner Content */}
      <div className="relative h-full flex flex-col justify-center items-center text-center text-white space-y-6 sm:space-y-16 px-2 sm:px-4 z-10">
        
        {/* Heading with Underline */}
        <div className="max-w-sm md:max-w-2xl">
          <h1 className="text-lg sm:text-3xl md:text-4xl font-normal leading-tight">
            End-to-End Logistics & Supply Chain Service Provider
          </h1>
          <div className="border-b-2 sm:border-b-4 border-white w-32 sm:w-64 mx-auto mt-2 sm:mt-5"></div>
        </div>

        {/* Transparent Boxes */}
        <div className="flex justify-around w-full max-w-sm sm:max-w-4xl z-10 sm:space-x-3">
          
          {/* Box 1 */}
          <div className="bg-white bg-opacity-5 border border-white rounded-lg py-1 px-2 sm:py-2 sm:px-6 shadow-lg flex flex-row items-center space-x-1 sm:space-x-2"
            style={{ boxShadow: 'inset 0 0 8px rgba(255, 255, 255, 0.4)' }}>
            <img src={experienceLogo} alt="experience" className="h-6 w-6 sm:h-10 sm:w-10" />
            <p className="text-xs sm:text-xl font-semibold">EXPERIENCE</p>
          </div>

          {/* Box 2 */}
          <div className="bg-white bg-opacity-5 border border-white rounded-lg py-1 px-2 sm:py-2 sm:px-6 shadow-lg flex flex-row items-center space-x-1 sm:space-x-2"
            style={{ boxShadow: 'inset 0 0 8px rgba(255, 255, 255, 0.4)' }}>
            <img src={loyaltyLogo} alt="loyalty" className="h-6 w-6 sm:h-10 sm:w-10" />
            <p className="text-xs sm:text-xl font-semibold">TRUST</p>
          </div>

          {/* Box 3 */}
          <div className="bg-white bg-opacity-5 border border-white rounded-lg py-1 px-2 sm:py-2 sm:px-6 shadow-lg flex flex-row items-center space-x-1 sm:space-x-2"
            style={{ boxShadow: 'inset 0 0 8px rgba(255, 255, 255, 0.4)' }}>
            <img src={trustLogo} alt="trust" className="h-6 w-6 sm:h-10 sm:w-10" />
            <p className="text-xs sm:text-xl font-semibold">LOYALTY</p>
          </div>
        
        </div>

      </div>
    </div>
  );
};

export default ServiceBanner;
